import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const NoMatchDiv = styled(BaseStyles.Div)`
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`

export const NoMatchComponentsDiv = styled(BaseStyles.Div)`
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.8rem;
    background-color: none;
    padding: 0.75%;
`
export const NoMatchContentsDiv = styled(BaseStyles.Div)`
    padding: 6rem 2rem;
    width: 100%;
`

export const QuickFillerTitleDiv = styled(BaseStyles.Div)`
    margin-bottom: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const QuickFillerTitle = styled.h1`
    margin: 0;
    padding: 0rem 16rem;
    background-color: transparent;
    outline-style: none;
    cursor: pointer;
    font-size: 3rem;
    font-weight: 200;
    color: gray;
    border: none;
    font-family: "Helvetica Neue";
`

export const NoMatchTitleDiv = styled(BaseStyles.Div)`
    text-align: center;
    width: 100%;
`

export const NoMatchPhraseDiv = styled(BaseStyles.Div)`
    display: flex; 
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const NoMatchTitle = styled.h2`  
    margin: 0;
    padding: 0;
    padding-bottom: 2rem;
    font-size: 3.5rem;
    font-weight: 200;
    color: gray;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`

export const NoMatchPhrase = styled.p`
    margin: 0;
    padding: 0;
    padding-top: 3rem;
    font-size: 2.4rem;
    font-weight: 200;
    color: gray;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    word-break: break-all;
`